import { computed, makeAutoObservable, observable } from "mobx";
import { createAr } from "../utils/api";
import { StoreClass } from "./Store";

const QRCode = require('qrcode')



export function prepareButton(el){
    /** @type {Element} */
    // var el = document.querySelector(selector);
    if(el){
        var file_url_glb = el.getAttribute('data-glb-url');
        var file_url_usdz = el.getAttribute('data-usdz-url');
        var vertical = 'true';
        var href = `intent://arvr.google.com/scene-viewer/1.0?file=${file_url_glb}&mode=ar_only&enable_vertical_placement=${vertical}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            href = `${file_url_usdz}#allowsContentScaling=0`;
        }
        el.href = href;
    }
}




class ArManagerClass{
    store: StoreClass
    @observable response;
    @observable pendingRequest = false;

    @computed get arModelUrl(){
        if(this.response?.url){
            return `${this.response?.url}&lang=${this.store.langCode}`;
        }
        return null;
    }
    constructor({store}){
        this.store = store;

        makeAutoObservable(this);

        if(!store){
            throw new Error('store is udefined');
        }
    }

    prepareButtons(){
        document.querySelectorAll("[data-glb-url]").forEach((el, i) =>{
            prepareButton(el);
        })
    }
   
    

    getSettingsObject(){
        var obj = {};

        const onLarge = this.store.selectedCategoryId === 50;
        const onSmall = this.store.selectedCategoryId === 38;
        

        this.store.categories.forEach(c => {
            const sp = this.store.selectedMaterials.find(m => c.id === m.category_id);

            

            
            if (c.code) {
                    
                if (sp) { 
                                    
                    if (onSmall && sp.hasSmall && sp.isLarge) {
                        obj[c.code] = null;   
                        return;    
                    }
                    if (onLarge && sp.hasLarge && sp.isSmall) {
                        obj[c.code] = null;
                        return;
                    }
                    if(!onSmall && !onLarge && sp.isSmall && sp.hasLarge){
                        obj[c.code] = null;
                        return;
                    }
                    
                    obj[c.code] = {
                        name: c.code,
                        type: sp.material?.subcategory?.code,
                        // color: sp.material.color,
                        channels: sp.channels,
                        textures: sp.texturesUrls,
                    };
                    
                }else{
                    obj[c.code] = null;
                }
            }
        });

 

    
        return obj;
    }

    getJSON(){
        return JSON.stringify(this.getSettingsObject());
    }


    async createAr(){
        this.response = null;
        try {
            const response = await createAr(this.getJSON());
            this.response = response.data;
            if(response.data?.success){

            }
            return this.response;
        } catch (err) {
            console.error(err);
            
        } finally{
            this.pendingRequest = false;
        }
    }
    
}

export default ArManagerClass;

